module.exports = __webpack_public_path__ + "img/slika41.2b0efccc.jpg";